module.exports = __webpack_public_path__ + "media/images/jumping/jumping-guy-5db52f4970dc384052a62153bdae4502.png";